import { map, uniqBy } from 'lodash';

class RelatedFormController {
  constructor($rootScope, eventsService, imgix, messageService) {
      this.$rootScope = $rootScope;
      this.eventsService = eventsService;
      this.imgix = imgix;
      this.messageService = messageService;
  }

  $onInit(){
      this.loading = true;
      this.activeEvents = [];
      if (!this.relatedCategories) {
        this.eventsService.collectCategories().then(response => {
          this.relatedCategories = response;
          this.loading = false;
        });
      } else {
        this.loading = false;
      }
      if (this.source.related){
        if (this.source.related.length >= 3){
          this.selections = this.source.related.slice(0, 3);
        }else{
          this.selections = this.source.related.concat(new Array(3-this.source.related.length));
        }
          this.activeEvents = map(this.source.related, event => {
            return {
              'related_event_id': event.related_event_id,
              'related_event_type': event.related_event_type
            };
          });
      }
      this.select = [];
      this.imgix.reload();
  }

  deslug(input){
      if (input){
        return input.split('\\')[1].replace(/([A-Z])/g, ' $1').trim();
      }
  }

  onSave(){
      this.source.related = uniqBy(
        this.selections.filter(selection => {
          return Object.keys(selection).length > 0;
        }), selection => {
          return selection.related_event_type + selection.related_event_id;
        });

      this.selections = this.source.related;
      let dispatch = {
        'origin_type': this.type,
        'origin_id': this.source.id,
        'related_events': map(this.source.related, related => {
          if (related) return {'related_event_type': related.related_event_type, 'related_event_id': related.related_event_id}; })
      };
      return this.eventsService.updateRelated(dispatch)
        .catch(() => {
          this.messageService.failure('The related events could not be updated');
          this.messageService.push();
        })
        .then(() => {
          this.messageService.success('The related events have been successfully updated');
          this.selections = this.source.related.concat(new Array(3-this.source.related.length));
          switch (this.type){
              case 'SpaDay':
                  this.formTab = 'day';
                  break;
              case 'Treatment':
                  this.formTab = 'treatment';
                  break;
          }
          this.messageService.push();
        });
  }

  currentEvent(key, event) {
    if ( (event.related_event_id === this.source.id && event.related_event_type === this.source.type_raw ) ) {
      return true;
    }
    return false;
  }

  removeEvent(index) {
    this.selections.splice(index,1);
    this.selections.push({});
  }

  selectEvent() {
    setTimeout(() => {this.imgix.reload();});
  }

  parsePrice(price, strip = false) {
    if ( strip ) {
      price = price.toString().split('.')[0];
    }
    return this.$rootScope.currentProperty.currency_symbol + price;
  }
}

RelatedFormController.$inject = [ '$rootScope', 'eventsService', 'imgix', 'messageService' ];

export default RelatedFormController;


// WEBPACK FOOTER //
// ./frontend/admin/app/modules/event/controllers/related.form.controller.js